export enum CategoryDisplayAs {
    Icon = 'icon',
    IconAndName = 'iconAndName',
}
